<template>
  <div class="order-hall-page">
    <!-- 顶部品牌Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(/index_bg.png)' }">
      <!-- <div class="banner-deco"></div> -->
      <div class="banner-content">
        <h1 class="brand-name">优行运车</h1>
        <p class="brand-slogan">专业的二手车代驾平台</p>
      </div>
    </div>

    <!-- Tab切换 -->
    <div class="tab-wrapper">
      <div class="tab-switcher">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          class="tab-item"
          :class="{ active: activeTab === tab.value }"
          @click="switchTab(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="order-list">
      <!-- 加载骨架 -->
      <div v-if="loading" class="skeleton-wrap">
        <div v-for="n in 3" :key="n" class="skeleton-card">
          <div class="skeleton-line w40"></div>
          <div class="skeleton-line w60"></div>
          <div class="skeleton-line w60"></div>
          <div class="skeleton-line w50"></div>
        </div>
      </div>

      <!-- 有数据 -->
      <template v-else-if="orders.length">
        <div
          v-for="order in orders"
          :key="order.id"
          class="order-card"
          @click="goDetail(order)"
        >
          <!-- 时间行 -->
          <div class="card-time-row">
            <span class="card-time">
              <i class="dot dot-gray"></i>
              {{ order.add_time }}
            </span>
          </div>

          <!-- 路线 + 抢单按钮 -->
          <div class="card-main">
            <div class="card-route">
              <div class="route-point route-start">
                <i class="dot dot-blue"></i>
                <span>{{ order.start_city_name }}</span>
              </div>
              <div class="route-line"></div>
              <div class="route-point route-end">
                <i class="dot dot-orange"></i>
                <span>{{ order.end_city_name }}</span>
              </div>
            </div>
            <div class="grab-btn" @click.stop="handleGrab(order)">
              抢单
            </div>
          </div>

          <!-- 底部信息 -->
          <div class="card-footer">
            <span class="distance">
              <i class="el-icon-location-outline"></i>
              距我{{ order.distance_km || '--' }}km
            </span>
            <span class="order-tag">{{ order.channelText }}</span>
            <!-- <span class="order-tag" v-if="order.tag">{{ order.tag }}</span> -->
          </div>
        </div>
      </template>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <svg class="empty-icon" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="30" y="20" width="50" height="65" rx="4" stroke="#999" stroke-width="2.5"/>
          <line x1="40" y1="35" x2="70" y2="35" stroke="#999" stroke-width="2" stroke-linecap="round"/>
          <line x1="40" y1="45" x2="70" y2="45" stroke="#999" stroke-width="2" stroke-linecap="round"/>
          <line x1="40" y1="55" x2="60" y2="55" stroke="#999" stroke-width="2" stroke-linecap="round"/>
          <circle cx="82" cy="78" r="18" stroke="#999" stroke-width="2.5"/>
          <line x1="95" y1="91" x2="105" y2="101" stroke="#999" stroke-width="3" stroke-linecap="round"/>
          <path d="M75 78 L79 82 L89 72" stroke="#4A90E2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="empty-text">暂无订单</p>
      </div>

      <!-- 底部加载区 -->
      <div v-if="orders.length" class="scroll-footer">
        <!-- 加载中 -->
        <div v-if="loadingMore" class="loading-indicator">
          <span class="spinner"></span>
          <span class="loading-text">加载中...</span>
        </div>
        <!-- 加载失败，点击重试 -->
        <div v-else-if="loadMoreError" class="load-error" @click="loadMore">
          加载失败，点击重试
        </div>
        <!-- 没有更多了 -->
        <div v-else-if="!hasMore" class="no-more-divider">
          <span class="divider-line"></span>
          <span class="no-more-text">没有更多了</span>
          <span class="divider-line"></span>
        </div>
      </div>
    </div>

    <!-- 抢单成功弹窗 -->
    <div v-if="showSuccess" class="modal-mask" @click="showSuccess = false">
      <div class="success-modal" @click.stop>
        <span class="modal-close" @click="showSuccess = false">
          <i class="el-icon-close"></i>
        </span>
        <div class="success-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#52c41a"/>
            <path d="M18 33 L28 43 L46 23" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="success-text">抢单成功，请及时提车运输！</p>
        <div class="success-order">
          <span>{{ grabbedOrder.start }}</span>
          <i class="el-icon-right"></i>
          <span>{{ grabbedOrder.end }}</span>
        </div>
        <button class="success-btn" @click="goMyOrders">立即查看</button>
      </div>
    </div>

    <TabBar />

    <!-- 合同签约提示弹窗 -->
    <div v-if="showSignModal" class="sign-mask" @click="showSignModal = false">
      <div class="sign-modal" @click.stop>
        <p class="sign-text">您的合同尚未签约，请先签约合同！</p>
        <div class="sign-btns">
          <button class="sign-btn cancel-btn" @click="showSignModal = false">取消</button>
          <button class="sign-btn confirm-btn" @click="handleSignNow">立即签约</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar.vue'
import { getOrderHall, robOrder, getSignUp } from '@/api/order'
import { getLat, getLng } from '@/utils/auth'

export default {
  name: 'OrderHall',
  components: { TabBar },
  data() {
    return {
      loading: false,
      loadingMore: false,
      loadMoreError: false,
      page: 1,
      size: 20,
      hasMore: true,
      activeTab: 0,
      tabs: [
        { label: '长途订单', value: 0 },
        { label: '同城订单', value: 1 }
      ],
      showSuccess: false,
      grabbedOrder: { start: '', end: '' },
      orders: [],
      scrollLock: false,
      showSignModal: false
    }
  },
  created() {
    this.fetchOrders()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (this.loading || this.loadingMore || !this.hasMore || this.scrollLock) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollHeight = document.documentElement.scrollHeight
      const clientHeight = window.innerHeight
      if (scrollTop + clientHeight >= scrollHeight - 120) {
        this.loadMore()
      }
    },
    async fetchOrders() {
      this.loading = true
      this.page = 1
      this.hasMore = true
      this.loadMoreError = false
      try {
        const res = await getOrderHall({
          page: this.page,
          size: this.size,
          target_lat: getLat(),
          target_lng: getLng(),
          same_city: this.activeTab
        })
        const list = res.data && res.data.list ? res.data.list : []
        this.orders = list
        this.hasMore = list.length >= this.size
      } catch (err) {
        this.orders = []
        this.$message.error(err.message || '获取订单列表失败')
      } finally {
        this.loading = false
      }
    },
    async loadMore() {
      if (this.loadingMore || !this.hasMore) return
      this.loadingMore = true
      this.loadMoreError = false
      this.page++
      try {
        const res = await getOrderHall({
          page: this.page,
          size: this.size,
          target_lat: getLat(),
          target_lng: getLng(),
          same_city: this.activeTab
        })
        const list = res.data && res.data.list ? res.data.list : []
        this.orders = this.orders.concat(list)
        this.hasMore = list.length >= this.size
      } catch (err) {
        this.page--
        this.loadMoreError = true
      } finally {
        this.loadingMore = false
      }
    },
    switchTab(val) {
      this.activeTab = val
      this.fetchOrders()
    },
    goDetail(order) {
      this.$router.push({ path: '/order-detail', query: { id: order.id } })
    },
    async handleGrab(order) {
      try {
        const res = await robOrder(order.id)
        if (res.code === 0) {
          this.grabbedOrder = { start: order.start_city_name, end: order.end_city_name }
          this.showSuccess = true
          this.fetchOrders()
        } else if (res.code == 2) {
          this.showSignModal = true
        } else {
          this.$message.error(res.msg || '抢单失败，请重试')
        }
      } catch (err) {
        this.$message.error(err.message || '抢单失败，请重试')
      }
    },
    async handleSignNow() {
      this.showSignModal = false
      try {
        const res = await getSignUp()
        if (res.code === 0 && res.data && res.data.url) {
          window.location.href = res.data.url
        } else {
          this.$message.error(res.msg || '获取合同链接失败')
        }
      } catch (err) {
        this.$message.error(err.message || '获取合同链接失败')
      }
    },
    goMyOrders() {
      this.showSuccess = false
      this.$router.push('/my-orders')
    }
  }
}
</script>

<style scoped>
.order-hall-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 56px;
}

/* 品牌Banner */
.banner {
  position: relative;
  overflow: hidden;
  height: 150px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  padding: 36px 20px 0;
}

.banner-content {
  position: relative;
  z-index: 1;
}

.brand-name {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.brand-slogan {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

/* Tab切换 */
.tab-wrapper {
  padding: 12px 16px 8px;
}

.tab-switcher {
  display: flex;
  background: #fff;
  border-radius: 24px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 9px 0;
  font-size: 15px;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.25s;
}

.tab-item.active {
  background: #4a90e2;
  color: #fff;
  font-weight: 600;
}

/* 订单列表 */
.order-list {
  padding: 4px 16px 16px;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.card-time {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #999;
}

.card-platform {
  font-size: 12px;
  background: #ff9500;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
}

.card-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.card-route {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.route-point {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.route-line {
  width: 1px;
  height: 8px;
  background: #e0e0e0;
  margin-left: 3.5px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.dot-gray { background: #ccc; }
.dot-blue { background: #4a90e2; }
.dot-orange { background: #ff9500; }

/* 圆形抢单按钮 */
.grab-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #4a90e2;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(74, 144, 226, 0.35);
}

.grab-btn:active {
  transform: scale(0.92);
}

/* 卡片底部 */
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.distance {
  font-size: 12px;
  color: #999;
}

.distance i {
  margin-right: 2px;
}

.order-tag {
  font-size: 11px;
  color: #ff9500;
  background: rgba(255, 149, 0, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

/* 骨架屏 */
.skeleton-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.skeleton-line {
  height: 14px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 12px;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
}

.skeleton-line:last-child { margin-bottom: 0; }

.w40 { width: 40%; }
.w50 { width: 50%; }
.w60 { width: 60%; }

@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
}

.empty-icon {
  width: 120px;
  height: 120px;
}

.empty-text {
  margin-top: 16px;
  font-size: 15px;
  color: #999;
}

/* 底部加载区 */
.scroll-footer {
  padding: 20px 0 8px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 22px;
  height: 22px;
  border: 2.5px solid #e0e0e0;
  border-top-color: #4a90e2;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: #999;
}

.load-error {
  text-align: center;
  font-size: 14px;
  color: #4a90e2;
  cursor: pointer;
  padding: 8px 0;
}

.load-error:active {
  opacity: 0.7;
}

.no-more-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.divider-line {
  width: 40px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #ddd, transparent);
}

.no-more-text {
  font-size: 13px;
  color: #bbb;
  white-space: nowrap;
}

/* 抢单成功弹窗 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.success-modal {
  position: relative;
  width: 80%;
  max-width: 300px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px 24px;
  text-align: center;
  animation: modal-in 0.3s ease;
}

@keyframes modal-in {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
}

.modal-close i {
  font-size: 18px;
}

.success-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
}

.success-text {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 16px;
}

.success-order {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
}

.success-order i {
  color: #4a90e2;
  font-size: 16px;
}

.success-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: #4a90e2;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.success-btn:active {
  opacity: 0.85;
}

/* 签约提示弹窗 */
.sign-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.sign-modal {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  animation: sign-in 0.25s ease;
}

@keyframes sign-in {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.sign-text {
  padding: 32px 24px 24px;
  text-align: center;
  font-size: 16px;
  color: #333;
  line-height: 1.6;
}

.sign-btns {
  display: flex;
  border-top: 1px solid #eee;
}

.sign-btn {
  flex: 1;
  height: 48px;
  border: none;
  font-size: 16px;
  background: transparent;
  cursor: pointer;
}

.sign-btn.cancel-btn {
  color: #999;
  border-right: 1px solid #eee;
}

.sign-btn.cancel-btn:active {
  background: #f5f5f5;
}

.sign-btn.confirm-btn {
  color: #4a90e2;
  font-weight: 500;
}

.sign-btn.confirm-btn:active {
  background: #f0f7ff;
}
</style>
